<template>
  <div class="food-manage">

    <div class="tuolele-main-box">
      <form-box ref="createcouponpostform" label-width="120px" :forms="forms" :rules="rules" :post-form="createPostForm" @submit="fnSubmit">
        <template v-slot:splite1="{currentForm, item}">
          <h4>优惠券使用规则</h4>
        </template>
        <template v-slot:ruleType="{currentForm, item}">
          <el-radio-group v-model="currentForm[item.bindValue]">
            <el-radio label="1">无门槛</el-radio>
            <el-radio label="2">满 <el-input v-model="currentForm['rule_amount']" style="width: 100px;" /> 可用</el-radio>
          </el-radio-group>
        </template>
      </form-box>

    </div>
  </div>
</template>
<script>

import FormBox from '@/components/FormBox'

const defaultCreatePostForm = {
  coupon_name: '',
  coupon_desc: '',
  deductible_amount: '',
  limited_number: '',
  ruleType: '1',
  rule_amount: 0,
  times: [],
  start_time: '',
  end_time: '',
  shop_id: []
}

export default {
  name: 'TurnStudentList',
  components: {
    // Select
    FormBox

  },

  data() {
    return {
      forms: [
        { type: 'input', bindValue: 'coupon_name', label: '优惠券名称', require: true },
        { type: 'textarea', bindValue: 'coupon_desc', label: '优惠券说明', require: true },
        { type: 'input', inputType: 'number', bindValue: 'deductible_amount', label: '优惠券面额', require: true },
        { type: 'input', inputType: 'number', bindValue: 'limited_number', label: '限发数量', require: true },
        { type: 'daterange', inputType: 'number', bindValue: 'times', label: '用券时间', mapValue: ['start_time', 'end_time'], require: true },
        { type: 'custom', bindValue: 'splite1' },
        { type: 'custom', bindValue: 'ruleType', label: '使用规则' },
        { type: 'select', dataFunc: this.$http.getMyShopList, multiple: true, bindValue: 'shop_id', label: '适用店铺', require: true }
      ],
      createPostForm: Object.assign({}, defaultCreatePostForm),
      rules: {
        ruleType: [{
          require: true,
          validator: (rule, value, callback) => {
            if (value === '1') {
              this.$refs.createcouponpostform.setPostForm('rule_amount', 0)
              callback()
            } else {
              if (!this.$refs.createcouponpostform.getPostFormInfo()['rule_amount']) {
                callback(new Error('请输入满多少可用'))
              } else {
                callback()
              }
            }
          },
          trigger: ['blur', 'change']
        }]
      }
    }
  },
  created() {
    if (this.$route.query.id) {
      this.createPostForm = Object.assign({}, defaultCreatePostForm, this.$route.query)
      this.createPostForm.times = [this.$route.query.start_time, this.$route.query.end_time]
      this.createPostForm.rule_amount = this.createPostForm.rule_amount / 100
      if (this.createPostForm.shop_id) {
        this.createPostForm.shop_id = this.createPostForm.shop_id.split(',')
      } else {
        this.createPostForm.shop_id = []
      }
      if (this.createPostForm.rule_amount == 0) {
        this.createPostForm.ruleType = '1'
      } else {
        this.createPostForm.ruleType = '2'
      }
      this.createPostForm.deductible_amount = this.createPostForm.deductible_amount / 100
    }
  },
  methods: {
    fnSubmit(postForm) {
      postForm.shop_id = postForm.shop_id.join(',')
      this.$http.improveCoupon(postForm).then(res => {
        if (res.code == 200) {
          this.$message.success('创建成功')
          this.$router.back()
        }
      })
    },
    fnCreate() {
      this.$router.push({ path: '/discount/consecutivemanage/create' })
    }
  }
}
</script>
<style lang="scss">
.wq_flex {
  display: -webkit-box;
  display: -webkit-flex;
  display: flex;
}

.wq_flex_wrap {
  flex-wrap: wrap;
}

.wq_flex_sub {
  -webkit-box-flex: 1;
  -webkit-flex: 1;
  flex: 1;
}

.el-image-viewer__wrapper .el-icon-circle-close {
  color:white
}
  .food-search {
  .tuolele-main-search-item {
    margin-bottom: 0;
    padding: 0;
    border: 0;
    .el-form--inline .el-form-item {
      display: block;
    }
    .split-time{
      margin-right: 20px;
    }
    .el-select,
    .el-input {
      width: 160px !important;
      margin-right: 20px;
    }
    span.select-date {
      margin-right: 10px;
    }
    .button-group {
      margin-left: 82px;
    }
  }
}
</style>
